import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Coins, ArrowUpRight, MapPin } from 'lucide-react';
import api from '../../lib/api';

/** Compact strip on the event detail page showing points-redeemable benefits linked to this event. */
export default function EventBenefitsStrip({ eventId }) {
  const [benefits, setBenefits] = useState([]);

  useEffect(() => {
    if (!eventId) return;
    api.get(`/fullbravx/benefits?event_id=${eventId}`)
      .then(r => setBenefits((r.data?.benefits || []).filter(b => !b.sold_out)))
      .catch(() => {});
  }, [eventId]);

  if (!benefits.length) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} data-testid="event-benefits-strip">
      <h2 className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-6">
        <Coins size={14} className="text-[#D4AF37]" />
        Canjeá tus puntos en este evento
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {benefits.map((b) => (
          <Link
            key={b.id}
            to="/fullbravx#canje"
            className="group flex items-center gap-4 rounded-xl border border-[#D4AF37]/25 bg-gradient-to-r from-[#D4AF37]/[0.07] to-transparent p-4 hover:border-[#D4AF37]/60 transition-colors"
            data-testid={`event-benefit-${b.id}`}
          >
            {b.image_url ? (
              <img src={b.image_url} alt="" className="w-14 h-14 rounded-lg object-cover flex-shrink-0" />
            ) : (
              <div className="w-14 h-14 rounded-lg bg-[#D4AF37]/10 border border-[#D4AF37]/40 flex items-center justify-center flex-shrink-0">
                <Coins size={20} className="text-[#D4AF37]" />
              </div>
            )}
            <div className="flex-1 min-w-0">
              <p className="text-white font-bold text-sm truncate">{b.title}</p>
              <p className="text-[#D4AF37] text-xs font-black">{b.points_cost.toLocaleString()} pts BRAVX</p>
              {b.location_label && (
                <p className="text-white/35 text-[10px] flex items-center gap-1 mt-0.5"><MapPin size={9} /> {b.location_label}</p>
              )}
            </div>
            <ArrowUpRight size={16} className="text-white/30 group-hover:text-[#D4AF37] transition-colors flex-shrink-0" />
          </Link>
        ))}
      </div>
    </motion.div>
  );
}
